import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ul className="conta">
                <li>
                  <i className="fa fa-map-marker" aria-hidden="true"></i> Genève, Avenue
                  Pictet-de-Rochemont, 19
                </li>
                <li>
                  <i className="fa fa-phone" aria-hidden="true"></i> Call : +41783118784
                </li>
                <li>
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                  <a href="mailto:roronails123@gmail.com"> roronails123@gmail.com</a>
                </li>
              </ul>
            </div>
            <div className="col-md-4 col-sm-6">
              <h3>Royal Nails Pro</h3>
              <p className="variat">
                Salon de manucure professionnel à Genève, proposant manucures, pédicures et
                nail art avec élégance et style
              </p>
            </div>

            <div className="col-md-4 col-sm-6">
              <h3>Heures d'ouverture</h3>
              <ul className="opening-hours" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ marginBottom: '10px', lineHeight: 1.6 }}>
                  <strong>Lundi - Vendredi</strong>
                  <span>09:00 - 20:00</span>
                </li>
                <li style={{ marginBottom: '10px', lineHeight: 1.6 }}>
                  <strong>Samedi</strong>
                  <span>10:00 - 20:00</span>
                </li>
                <li style={{ marginBottom: '10px', lineHeight: 1.6 }}>
                  <strong>Dimanche</strong>
                  <span>Fermé</span>
                </li>
              </ul>
            </div>
            <div className="col-md-2">
              <ul className="social_icon">
                <li>
                  <a
                    href="https://www.facebook.com/people/Rodyka-Soltan/61572131475024/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow Rodyka Soltan on Facebook"
                  >
                    <i className="fa fa-facebook" aria-hidden="true"></i>
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.tiktok.com/@rodicasoltan"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow Rodyka Soltan on TikTok"
                  >
                    <i className="fab fa-tiktok" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/in/soltan-rodyka-293704377"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Connect with Rodyka Soltan on LinkedIn"
                  >
                    <i className="fa fa-linkedin" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/rodyka_soltan?igsh=MW84cjRreW9tbnJrZQ=="
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow Rodyka Soltan on Instagram"
                  >
                    <i className="fa fa-instagram" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-12">
              <h3> </h3>
              <ul className="link_menu">
                <li>
                  <Link to="/">Accueil</Link>
                </li>
                <li>
                  <Link to="/about">À propos</Link>
                </li>
                <li>
                  <Link to="/gallery">Nos activités</Link>
                </li>
                <li>
                  <Link to="/services">Services</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className="container">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <p>© 2025 Royal Nails Pro. All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

